var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFailedTriangle = function SvgFailedTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 92,
    height: 92,
    rx: 46,
    fill: "#BF0637",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.274 55.147 54.34 28.267c-2.006-3.617-4.783-5.6-7.84-5.6-3.056 0-5.833 1.983-7.84 5.6l-14.933 26.88c-1.89 3.43-2.1 6.72-.583 9.31 1.516 2.59 4.503 4.013 8.423 4.013h29.867c3.92 0 6.906-1.424 8.423-4.013 1.517-2.59 1.307-5.904-.583-9.31ZM44.75 39c0-.957.794-1.75 1.75-1.75.957 0 1.75.793 1.75 1.75v11.666c0 .957-.793 1.75-1.75 1.75-.956 0-1.75-.793-1.75-1.75V39Zm3.407 20.323-.35.28a1.77 1.77 0 0 1-.42.21c-.14.07-.28.117-.443.14-.14.023-.304.047-.444.047s-.303-.023-.466-.047c-.14-.023-.28-.07-.42-.14a1.77 1.77 0 0 1-.42-.21l-.35-.28a2.454 2.454 0 0 1-.677-1.657c0-.606.257-1.213.677-1.656l.35-.28c.14-.093.28-.163.42-.21.14-.07.28-.117.42-.14.303-.07.63-.07.91 0 .163.023.303.07.443.14.14.046.28.116.42.21l.35.28c.42.443.677 1.05.677 1.657 0 .606-.257 1.213-.677 1.656Z",
    fill: "#BF0637"
  })));
};
export default SvgFailedTriangle;